import { apiRegistry } from '../../../common/infra/apiRegistry'
import { wordsMem } from '../mem/wordsMem'

apiRegistry.registerGetApi('searchWord', async (req) => {
  const query = req.query.toLowerCase()

  if (!query) {
    return { suggestions: [] }
  }

  const suggestions = Object.keys(wordsMem)
    .filter(word => word.toLowerCase().startsWith(query))
    .slice(0, 10)

  return { suggestions }
})
